<template>
  <div>
    <div class="font-medium text-flexopus-black">
      <h3>{{ userName }}</h3>
      <h5 class="text-sm text-microsoft-blue-default flex">
        {{ userEmail }}
        <button
          class="transition-all duration-200 hover:text-microsoft-blue-dark ml-2 cursor-pointer"
          @click="copy"
        >
          <Copy
            v-if="!isCopied"
            class="w-4 h-4"
          />
          <Check
            v-else
            class="w-4 h-4"
          />
        </button>
      </h5>
    </div>
    <div class="divider my-6" />
    <div class="text-sm">
      <div class="flex justify-between text-neutral-gray-700">
        <h6 class="font-bold text-neutral-gray-700">
          {{ $t('App.Tenant') }}
        </h6>
        <a
          class="cursor-pointer font-medium text-microsoft-blue-default hover:text-microsoft-blue-dark transition"
          target="_blank"
          :href="tenant"
        >
          {{ tenantDomain }}
        </a>
      </div>
      <div class="flex justify-between mt-2 text-neutral-gray-700">
        <h6 class="font-bold">
          {{ $t('App.Version') }}
        </h6>
        <h6 class="font-medium">
          {{ version }}
        </h6>
      </div>
    </div>
    <div class="divider my-6" />
    <plugin-details />
    <button
      class="btn btn-secondary mt-3 w-full"
      @click="onLogout"
    >
      <LogOut class="w-5 h-5 mr-2" /> {{ $t('App.SignOut') }}
    </button>
  </div>
</template>

<script>
import PluginDetails from '@/components/PluginDetails.vue'
import { Copy, Check, LogOut } from 'lucide-vue'

export default {
  components: {
    PluginDetails,
    Copy,
    Check,
    LogOut,
  },
  props: {
    version: {
      required: true,
      type: String,
    },
    userName: {
      required: true,
      type: String,
    },
    userEmail: {
      required: true,
      type: String,
    },
    tenant: {
      required: true,
      type: String,
    },
  },
  data () {
    return {
      isCopied: false,
    }
  },
  computed: {
    tenantDomain () {
      try {
        return new URL(this.tenant).hostname
      } catch (e) {
        return this.tenant
      }
    },
  },
  methods: {
    onLogout () {
      this.$emit('logout')
    },
    async copy () {
      // The document.execCommand method is obsolete but navigator.clipboard is not available
      // because Microsoft did not add allow="clipboard-write" to it's iframe tag.
      const input = document.createElement('input')
      input.type = 'text'
      input.value = this.userEmail
      document.body.append(input)
      input.select()
      document.execCommand('copy')
      input.remove()
      this.isCopied = true

      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
  },
}
</script>

<style scoped>
</style>
